module.exports = __webpack_public_path__ + "static/img/banner-en.3d08c1a1.png";